import SectionHeading from "@/pages/home/components/SectionHeading";
import { safetyTips } from "@/mocks/siteData";

export default function SafetyTips() {
  return (
    <section id="safety" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <SectionHeading
          eyebrow="Safety Notes"
          title="使用须知与安全建议"
          desc="无论从哪个入口进入，下面这些提醒都值得每次留意。它们与具体地址无关，却能显著降低你遇到风险的概率。"
        />

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {safetyTips.map((tip) => (
            <div
              key={tip.title}
              className="p-5 md:p-6 rounded-xl bg-background-100 border border-background-200 hover:border-secondary-300 transition-colors"
            >
              <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                <i className={`${tip.icon} text-xl`} />
              </span>
              <h3 className="mt-4 text-base font-heading font-bold text-foreground-950">
                {tip.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                {tip.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}